import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ParentType } from 'src/app/models/enums/parentType';
import { Kid } from 'src/app/models/kid';
import { PackageRequest } from 'src/app/models/package-request';
import { Parent, ParentForm } from 'src/app/models/parent';
import { KidService } from 'src/app/services/kid.service';
import { MessagesService } from 'src/app/services/messages.service';
import { ParentService } from 'src/app/services/parent.service';
import { WaitIndicatorService } from 'src/app/services/wait-indicator.service';

@Component({
    selector: 'app-edit-parent-form',
    templateUrl: './edit-parent-form.component.html',
    styleUrls: ['./edit-parent-form.component.scss']
})
export class EditParentFormComponent {
    private _parent: Parent | undefined;
    public parentTypes: (string | ParentType)[] = Object.values(ParentType);
    public parentForm: FormGroup<ParentForm>;
    public kids: Kid[] = [];
    public selectedKids: Kid[] = [];

    @Input()
    public request?: PackageRequest

    @Input()
    public secondParent: boolean = false;

    public get parent(): Parent | undefined {
        return this._parent;
    }
    @Input()
    public set parent(v: Parent | undefined) {
        this._parent = v;
        this.parentForm.reset();
        this.dialogText = 'Редактирай';
        if (!this._parent) {
            this._parent = this._emptyParent();
            this.parentForm.reset();
            this.dialogText = 'Добави';
            this.parentForm.controls.name.reset(this.secondParent === false ? this.request?.parentName : this.request?.secondParentName);
            this.parentForm.controls.email.reset(this.secondParent === false ? this.request?.parentEmail : '');
            this.parentForm.controls.phone.reset(this.secondParent === false ? this.request?.parentPhone : this.request?.secondParentPhone);
            for (let kid of this.selectedKids) {
                kid = this.kids.find(k => k.id === kid.id)!;
            }
            this.parentForm.controls.kids.reset(this.selectedKids.map(k => k.id!));
        } else {
            this.parentForm.reset({
                name: this._parent.name,
                email: this._parent.email,
                phone: this._parent.phone,
                parentType: this._parent.parentType,
                kids: this._parent.kids.map(k => k.id!),
            });
        }
    }

    public dialogText: string = '';

    @Output() public done: EventEmitter<Parent | undefined> = new EventEmitter<Parent | undefined>();

    constructor(
        private parentService: ParentService,
        private kidsService: KidService,
        private msgs: MessagesService,
        private wait: WaitIndicatorService,
    ) {
        this.parentForm = new FormGroup<ParentForm>({
            name: new FormControl('', Validators.required),
            parentType: new FormControl(null),
            email: new FormControl(null),
            phone: new FormControl(null),
            kids: new FormControl([]),
        });
        this.load();
    }

    public parentSubmit = (): void => {
        this.wait.show();
        this._saveParent()
    }

    private _saveParent = async () => {
        try {
            const data: any = this.parentForm.value;
            if (this.dialogText === 'Добави') {
                const result = await this.parentService.add(data);
                this.msgs.success(`Родител ${result.name} е успешно добавен.`);
                this.done.emit(result);
            } else {
                const result = await this.parentService.update({ ...data, id: this.parent?.id?.replaceAll('-', '') });
                this.msgs.success(`Родител ${result.name} е успешно редактиран.`);
                this.done.emit(result);
            }
            this._parent = undefined;
            this.parentForm.reset();
            this.wait.hide();
        }
        catch (err) {
            this.msgs.error(err);
            this.wait.hide();
        }
    }

    private _emptyParent = (): Parent => {
        const result: Parent = {
            name: '',
            email: '',
            phone: '',
            parentType: ParentType.Other,
            kids: [],
        }
        return result;
    }

    private load = async () => {
        this.wait.show();
        this.kids = await this.kidsService.allKids();
        this.wait.hide();
    }
}
